export default "__VITE_PUBLIC_ASSET__6d2c072e__"